import { AppProductTypeEnum } from 'src/graphql/schema';

const SHARED_PRODUCT_TYPES: AppProductTypeEnum[] = [
  AppProductTypeEnum.SoftwareEscrow,
  AppProductTypeEnum.SaasEscrow,
  AppProductTypeEnum.ContinuityEscrow,
];

export const isSharedProduct = (productType: AppProductTypeEnum): boolean => SHARED_PRODUCT_TYPES.includes(productType);

export const isProductVisible = (productType: AppProductTypeEnum, owned: boolean): boolean =>
  owned || isSharedProduct(productType);
